import React, { useMemo } from 'react'
import styled from '@emotion/styled'
import { FormattedMessage } from 'react-intl'
import withRetailerRouter from 'legacy/common/withRouter'
import { type ShiftsRouteQuery } from 'domains/shifts/components/types'
import { type RetailerRouteComponentProps } from 'legacy/components/RetailerRoute'
import { Alert } from 'legacy/dash-components/alert/Alert'
import { useWarehouseContext } from 'utils/contexts/warehouse/WarehouseContext.hooks'

const Container = styled.div({
  backgroundColor: 'white',
})

interface Props extends RetailerRouteComponentProps<{}, ShiftsRouteQuery> {}

const ShiftWarning: React.FC<Props> = props => {
  const { query } = props

  const warehouseContext = useWarehouseContext()

  const selectedWarehouseLocation = useMemo(() => {
    if (!warehouseContext || !warehouseContext.loaded) {
      return null
    }

    const { warehouseLocations, inactiveWarehouseLocations } = warehouseContext.warehouse

    const allWarehouseLocations = [...warehouseLocations, ...inactiveWarehouseLocations]

    return allWarehouseLocations.find(
      warehouseLocation => warehouseLocation.id === query.warehouse_location_id
    )
  }, [query.warehouse_location_id, warehouseContext])

  return (
    <Container>
      {selectedWarehouseLocation?.pickup === false && (
        <Alert>
          <FormattedMessage id="shiftsDomain.pickupWarning" />
        </Alert>
      )}

      {selectedWarehouseLocation?.active === false && (
        <Alert>
          <FormattedMessage id="shiftsDomain.inactive" />
        </Alert>
      )}
    </Container>
  )
}

export default withRetailerRouter(ShiftWarning)
